/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable no-unused-vars */
import React, { useEffect, useMemo, useState } from "react";
import { Helmet } from "react-helmet-async";
import { useDispatch, useSelector } from "react-redux";
import { suggestPrompt } from "../asset";
import { getConfig } from "../store/config-action";
import { uiAction } from "../store/ui-gemini";
import { shuffleArray } from "../utils/utils";
import SlideSection from "../components/Slide/index";
import ChatSection from "../components/ChatSection/ChatSection";
import LoginRequiredModal from "../components/Ui/LoginRequiredModal";
import WelcomeModal from "../components/Ui/WelcomeModal";

const Share = () => {
  document.documentElement.setAttribute('data-theme', localStorage.getItem('theme') || 'light');
  const dispatch = useDispatch();
  const isWelcomeModalOpen = useSelector((s) => s.ui.isWelcomeModalOpen);
  const [suggest, setSuggest] = useState(suggestPrompt);
  const [index, setIndex] = useState(1);
  const userDetails = useSelector((s) => s.user.user);

  useEffect(() => {
    const intervalId = setTimeout(() => {
      setIndex((pre) => pre + 1);
      if (index >= suggestPrompt.length) {
        setSuggest(shuffleArray(suggestPrompt));
        setIndex(1);
      }
    }, 2000);

    return () => {
      clearInterval(intervalId);
    };
  }, [index]);

  useEffect(() => {
    dispatch(getConfig());
  }, []);

  // Remove auto-open Welcome modal; it will open after 5 rate-limit hits


  const meta = useMemo(() => {
    const title = "Gospel Truth AI";
    const description = "Gospel Truth AI";
    return (
      <Helmet>
        <meta name="robots" content="index,follow" />
        <title>{title}</title>
        <meta name="description" content={description} />
        <link rel="canonical" href={window?.location?.href} />
        <meta property="og:type" content="article" />
        <meta property="og:title" content={title} />
        <meta property="og:description" content={description} />
        <meta property="og:url" content={window?.location?.href} />
        <meta property="og:site_name" content="Gospel Truth AI" />

        <meta name="twitter:card" content="summary" />
        <meta name="twitter:title" content={title} />
        <meta name="twitter:description" content={description} />
        <meta name="twitter:url" content={window?.location?.href} />

        <meta itemProp="name" content={title} />
        <meta itemProp="description" content={description} />
      </Helmet>
    );
  }, []);

  // Disable auto-open slide on landing; it will be opened from header button

  return (
    <div className=" h-screen">
      {!isWelcomeModalOpen && <SlideSection />}
      {meta}
      <ChatSection />
      <LoginRequiredModal />
      <WelcomeModal />
    </div>
  );
};

export default Share;
